/**
 * @desc 保存
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.SystemForecastRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/wms/systemForecast/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
